import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { Table, Tag, message } from 'antd';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import portalService from '../../services/portalService';

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('es-PE', { year: 'numeric', month: 'short', day: 'numeric' });
};

const formatMoney = (value) => {
  if (value == null) return '—';
  return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(Number(value));
};

const MisPagos = () => {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      try {
        const data = await portalService.obtenerMisPagos();
        setPagos(Array.isArray(data) ? data : []);
      } catch {
        message.error('No se pudieron cargar sus pagos');
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  const columns = [
    {
      title: 'Inmueble',
      key: 'inmueble',
      render: (_, r) => r.contrato?.inmueble?.nombre || '—',
    },
    {
      title: 'Fecha programada',
      dataIndex: 'fecha_pago',
      render: formatDate,
    },
    {
      title: 'Fecha de pago',
      dataIndex: 'fecha_real_pago',
      render: formatDate,
    },
    {
      title: 'Monto',
      dataIndex: 'monto',
      render: formatMoney,
    },
    {
      title: 'Método',
      dataIndex: 'metodo_pago',
      render: (v) => v || '—',
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      render: (estado) => (
        <Tag color={estado === 'pagado' ? 'success' : estado === 'atrasado' ? 'error' : 'processing'}>
          {estado || '—'}
        </Tag>
      ),
    },
  ];

  return (
    <div>
      <Header />
      <Sidebar activeClassName="mis-pagos" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="#">Mi portal</Link></li>
              <li className="breadcrumb-item"><FaChevronRight /></li>
              <li className="breadcrumb-item active">Mis pagos</li>
            </ul>
          </div>
          <div className="card">
            <div className="card-body">
              <h4 className="mb-3">Mis pagos y recibos</h4>
              <Table
                rowKey="id"
                columns={columns}
                dataSource={pagos}
                loading={loading}
                pagination={{ pageSize: 10 }}
                locale={{ emptyText: 'No tiene pagos registrados' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MisPagos;
